import DataController from '../data/data.controller';
import NavigationController from './navigation.controller';
import { getAuthCookie, removeAuthCookie, removeUserRole } from '../utils/cookies';

class ClockoutController extends NavigationController {
    user = null;
    data = DataController.Instance();
    static _authSubscribers = new Set(); // Track all mounted instances

    // Get current auth state
    get isAuthenticated() {
        return getAuthCookie() !== 'expired';
    }

    // Called when auth state changes (login/logout). Router assigns this static
    // to force a re-render when the session cookie changes (see router.js).
    static _notifyAuthChange() {
        this._authSubscribers.forEach(instance => {
            if (instance.onAuthChange) instance.onAuthChange();
        });
    }

    /** Clears session and navigates to sign-in. Single path for explicit logout. */
    logout() {
        removeAuthCookie();
        removeUserRole();
        DataController.clearSession();
        // Reach the static hook on the controller class so router/auth subscribers update.
        this.constructor._notifyAuthChange?.();
        this.navigateLogin();
    }

    /**
     * Check if the current session user's role for a given FI carries a
     * scope. Synchronous — reads the `scopes`/`scopesByAba` already resolved
     * into `user` by GET /api/user, same source of truth `useHasScope()`
     * reads reactively elsewhere. Replaces the old `hasAccessByRole()`, which
     * compared role *names* — unsafe once an FI can rename or delete its own
     * roles (role names are no longer part of the session payload at all).
     * @param {string} scope - e.g. 'admin:roles:manage'
     * @param {string} [aba] - FI ABA; defaults to the primary FI
     * @returns {boolean}
     */
    hasScope(scope, aba) {
        if (!scope) return false;

        const user = this.user ?? this.data?.user;
        if (!user) return false;

        const scopes = aba
            ? (user.scopesByAba?.[aba] || [])
            : (user.scopes || []);
        return scopes.includes(scope);
    }

    async initialize() {}

    async cleanup() {}

    async componentDidMount() {
        this.constructor._authSubscribers.add(this);
        if (!this.data.user) {
            this.user = await this.data.fetchUserByToken();
        } else {
            this.user = this.data.user;
        }
        await this.initialize();
    }

    async componentWillUnmount() {
        await this.cleanup();
        this.constructor._authSubscribers.delete(this);
    }
}

export default ClockoutController;
